



































































































































































import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      host: process.env.VUE_APP_DATA_HTTP
    };
  },
  methods: {
    openLink(link: string, blank: boolean = true): void {
      window.open(link, blank ? "_blank" : "");
    }
  },
  mounted() {
    document.title = "Hydromapper - Kontakt";
    this.$store.commit("setToolbarTitle", "Kontakt");
  }
});
